<template>
    <transition name="fade">
        <template v-if="errors && errors.length">
            <div>
                <p class="text-danger mt-3" v-for="err in errors">
                    {{ err.fieldName }}{{ (err.fieldName && err.message) ? ': ' : '' }}{{ err.message }}
                </p>
            </div>
        </template>
    </transition>
</template>

<script>
    export default {
        props: ['errors']
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s .7S
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>